import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ClearingHouse} from "../../../model/exchange/clearing-house";
import {ExchangeClearingHouseService} from "../../../services/exchange/exchange-clearing-house.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-house',
  templateUrl: './clearing-house.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ClearingHouseComponent extends CrudBaseComponent<ClearingHouse> {

  //fields
  timeZones: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              clearingHouseService: ExchangeClearingHouseService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = clearingHouseService;
    this.newRecord = new ClearingHouse();
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'clearingHouseCode',
        width: 130
      },
      {
        field: 'description',
        width: 300
      },
      {
        field: 'timeZone',
        // icon: (value: ClearingHouse) => value.timeZone ? 'flag-icon flag-icon-' + value.timeZone.toLowerCase() : '',
        // mapId: value => ''
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'clearingHouseCode',
            required: true,
            column: 6,
            type: TYPE.TEXT,
          },
          {
            field: 'timeZone',
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            // icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
            options: () => this.timeZones,
            changed: event => {
              this.formRecord.timeZone = event.value.toUpperCase();
            }
          },
          {
            field: 'description',
            column: 12,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.formLoading = true;
    this.commonFieldService.getTimeZones(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.timeZones = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.formLoading = false;
    })
  }

  onFormShow() {
  }
}
